import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailPassRestoreComponent } from './email-pass-restore/email-pass-restore.component';
import { RestoreWithAuthenticationComponent } from './restore-with-authentication/restore-with-authentication.component';
import { IUserData, UserData } from '../../../globals/classes/userData';
import { BaseComponent } from '../../../globals/classes/base.component';
import { AppSettings } from '../../app.settings';
import { BlockedBusinessModalComponent } from '../blocked-business-modal/blocked-business-modal.component';
import { CardModalComponent } from '../card-modal/card-modal.component';
import { ForgetCredentialsRetailModalComponent } from '../forget-credentials-retail-modal/forget-credentials-retail-modal.component';
import { RestorePasswordWithCardComponent } from './restore-with-card/restore-password-with-card.component';

@Component({
	selector: 'password-retrieval',
	template: require('./password-retrieval.component.html')
})
export class PasswordRetrievalComponent extends BaseComponent implements OnInit {
	public isLoginBigModalEnabled: boolean = AppSettings.isLoginBigModalEnabled;
	public userData: IUserData = new UserData();
	@Input() public isCorporate: boolean = false;
	@Input() blockedUser: boolean = false;
	@Input() isForgotPasswordClicked: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	constructor(private modalService: NgbModal, private activeModal: NgbActiveModal) {
		super();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	ngOnInit() {
		this.mortalize(UserData.data$).subscribe((userData) => {
			if (!userData) return;
			this.userData = userData;
		});
	}

	selectRetrieval(component: string): void {
		switch (component) {
			case 'email':
				this.setDynatraceEvent('IB_PR_Select_Email');
				this.activeModal.close();
				let modalRef = this.modalService.open(EmailPassRestoreComponent, {
					windowClass: !this.isLoginBigModalEnabled ? 'modal-small' : 'modal-full',
				});
				modalRef.componentInstance.isCorporate = this.isCorporate;

				break;
			case 'data':
				this.setDynatraceEvent('IB_PR_Select_PersonalInfo');
				this.activeModal.close();
				this.modalService.open(RestoreWithAuthenticationComponent, {
					windowClass: !this.isLoginBigModalEnabled ? 'modal-small' : 'modal-full',
				});

                break;
			case 'card':
				this.setDynatraceEvent('IB_PR_Select_Card');
				this.activeModal.close();
				this.modalService.open(RestorePasswordWithCardComponent, {
					windowClass: !this.isLoginBigModalEnabled ? 'modal-small' : 'modal-full'
				});

			default:
				break;
		}
	}

	public toggleBlocked() {
		this.activeModal.close();
		const modalRef = this.modalService.open(BlockedBusinessModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as BlockedBusinessModalComponent).blockedUser =
			this.blockedUser;
		(modalRef.componentInstance as BlockedBusinessModalComponent).isForgotPasswordClicked =
			this.isForgotPasswordClicked;
	}
}
